import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';

import ExceptionHandling from "shared/logging/exception_handling";

import Select from "shared/select";

const DEFAULT_SELECT_PAGE_SIZE = 50;

class Async extends React.Component {
  componentDidMount() {
    this.initializeSelect2Plugin();
  }

  render() {
    return (
      <select
        className="select2 select2-initial"
        ref={input => {
          this.selectInput = input;
          this.props.setInput(input);
        }}
      />
    );
  }

  initializeSelect2Plugin() {
    const {
      url,
      width,
      allowSearch,
      placeholderText: placeholder,
      friendlyNameField: textAttr
    } = this.props;

    const options = {
      placeholder,
      width,
      allowClear: false,
      minimumResultsForSearch: allowSearch ? undefined : -1,
      theme: 'bootstrap'
    };

    if (url) {
      const itemsAttr = 'items';
      const pageSize = DEFAULT_SELECT_PAGE_SIZE;

      options.ajax = {
        url,
        delay: 250,
        headers: {
          "X-Select2": "1"
        },
        dataType: 'json',
        data(params) {
          const page = params.page || 1;

          const data = {
            query: params.term, // search term
            start: (page - 1) * pageSize,
            limit: pageSize,
            ajax: true
          };
          return data;
        },
        processResults(data, params) {
          const page = params.page || 1;
          const more = (page * pageSize) < data.total_results; // whether or not there are more results available

          // parse the results into the format expected by Select2.
          if (data[itemsAttr]) {
            const results = {
              pagination: {
                more
              },
              results: data[itemsAttr].map(row => {
                let resultRow = row;

                if (textAttr === 'text') {
                  return resultRow;
                } else {
                  return _.extend({}, resultRow, { text: resultRow[textAttr] });
                }
              })
            };

            return results;
          } else {
            ExceptionHandling.logWarning(`Select2 Controls.js: Response data did not contain outer key of '${itemsAttr}'`);

            return {
              results: []
            };
          }
        }
      };
    }

    if (this.props.showIdFromNetwork) {
      options.templateResult = Select.advertiserCampaignTemplateResult;
    }

    this._initAjaxSelection(() => {
      this.createDefaultOptions();
      $(this.selectInput).select2(options);
    });
  }

  createDefaultOptions() {
    const { placeholderText, node, uniqueNameField } = this.props;

    if (node.has(uniqueNameField)) {
      const initialId = node.get(uniqueNameField);
      const initialText = node.get(`${uniqueNameField}_label`) || "1 selected";

      $(this.selectInput).append(new Option(initialText, initialId, true, true));
    }

    if (placeholderText) {
      $(this.selectInput).append(new Option('', ''));
    }
  }

  _initAjaxSelection(callback) {
    const { node, uniqueNameField, friendlyNameField, url } = this.props;

    if (node.get(uniqueNameField) && node.get(friendlyNameField)) {
      // put the friendly field into the _label version -- TODO: this should be supported by Control and handled internally, to avoid adding attributes to a model
      node.set(uniqueNameField + "_label", node.get(friendlyNameField), { silent: true });
      callback();
    } else if (node.get(uniqueNameField)) {
      const defaultSelectedValue = node.get(uniqueNameField);

      $.ajax({
        url,
        data: { query: defaultSelectedValue },
        beforeSend: function(xhr) {
          xhr.setRequestHeader("X-Select2", "1");
        },
        success: response => {
          const field = _.find(response.items, field => {
            if (field[uniqueNameField]) {
              return field[uniqueNameField].toLowerCase() === defaultSelectedValue.toLowerCase();
            }
          });

          if (field) {
            node.set(uniqueNameField + "_label", field[friendlyNameField], { silent: true });
          }
        }
      }).always(callback);
    } else {
      callback();
    }
  }
}

Async.propTypes = {
  // Required
  friendlyNameField: PropTypes.string.isRequired, // I.e. id_from_network
  uniqueNameField: PropTypes.string.isRequired, // I.e. id
  node: PropTypes.object.isRequired,
  setInput: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired, // For AJAX-based lists

  // Optional
  allowSearch: PropTypes.bool,
  width: PropTypes.string,
  showIdFromNetwork: PropTypes.bool,
  placeholderText: PropTypes.string
};

export default Async;
